import {
  Button,
  FormControl,
  Grid,
  TextField,
  Chip,
  Tooltip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import { dateConfig } from "config";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getLocations } from "redux/actions/appActions";
import { properCase } from "utils";
import WeekPicker from "../../Review/components/WeekPicker";
import { EventEmitter } from "utils/EventEmitter";
import {CUSTOMER_SITE, REMOTE} from "../../../config/CONSTANTS";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const DropDowns = (props) => {
  const { t } = useTranslation();
  const {
    onChangeSelections,
    loading,
    setLoading,
    onChangeAverage,
    onChangePrimary,
    onClickLoad,
    existingPlans = [],
  } = props;
  const classes = useStyles();
  const [district, setDistrict] = React.useState(null);
  const { auth } = useSelector((state) => state.user);
  const { locations } = useSelector((state) => state.appConfig);
  const dispatch = useDispatch();
  const [districts, setDistricts] = React.useState([]);
  const [selectedBuildings, setSelectedBuildings] = React.useState({ });
  const [buildings, setBuildings] = React.useState([]);
  // const [existingPlans, setExistingPlans] = React.useState([]);
  const [selectedPlan, setSelectedPlan] = React.useState(null);
  const [averageBy, setAverageBy] = React.useState(null);
  const [dispatched, setDispatched] = React.useState(false);
  const [locationsLoaded, setLocationsLoaded] = React.useState(false);
  const [primary, setPrimary] = useState(null);
  const [week, setWeek] = React.useState(
    moment().startOf("week").format(dateConfig.format6)
  );
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedWeek, setSelectedWeek] = useState(localStorage.getItem('dscWeek') ? localStorage.getItem('dscWeek') : new Date());

  const weekChangeHandler = (date) => {
    localStorage.setItem('dscWeek', date);
    setSelectedWeek(date);
    const weekStart = moment(date).format(dateConfig.format6);
    setWeek(weekStart);
    console.log("WEEK SELECTION: weekStart: ", weekStart);
  };

  React.useEffect(() => {
    const buildings = selectedBuildings.value? [selectedBuildings.value]:[];
    onChangeSelections({ week, district });
  }, [week, district]);

  useEffect(() => {
    const selectedDistrictCache = localStorage.getItem('dscDistrict');
    const selectedWeekCache = localStorage.getItem('dscWeek');
    if ( selectedDistrictCache && typeof selectedDistrictCache === 'string' || selectedDistrictCache instanceof String){
      const parsedDistrict = JSON.parse(selectedDistrictCache);
      if(parsedDistrict){
          setSelectedDistrict(parsedDistrict);
          setDistrict(parsedDistrict?.value);
          setPrimary(parsedDistrict?.value);
          const filteredBuldings = parsedDistrict.buildings.length>0 ? parsedDistrict.buildings.filter(build => build.value !== CUSTOMER_SITE && build.value !== REMOTE ) :[]
          setBuildings(filteredBuldings);
          setSelectedBuildings([]);
          setSelectedPlan(null);
      }
      console.log("selectedDistrictCache", parsedDistrict);
    }
    if ( selectedWeekCache && typeof selectedWeekCache === 'string' || selectedWeekCache instanceof String){
      const parsedWeek = Date.parse(selectedWeekCache);
      const weekStart = moment(parsedWeek).format(dateConfig.format6);
      setWeek(weekStart);
      console.log("parsedWeek",selectedWeekCache,  parsedWeek);
    }
  }, [])

  // React.useEffect(() => {
  //   onChangeAverage(averageBy);
  // }, [averageBy]);

  React.useEffect(() => {
    onChangePrimary(primary);
  }, [primary]);

  React.useEffect(() => {
    setLoading(true);
    if (auth && auth.user) {
      if (locations && locations.default) {
        setLoading(false);
      } else {
        if (!dispatched) {
          console.log("DSC_Dispatched");
          dispatch(getLocations("testCountry"));
          setDispatched(true);
        }
      }
    }
  }, [auth, locations]);

  React.useEffect(() => {
    if (
      locations &&
      locations.default &&
      locations.default.length > 0 &&
      !locationsLoaded
    ) {
      console.log("DSC_Locations", locations.default);
      setDistricts(locations.default);
      setLoading(false);
      setLocationsLoaded(true);
    }
  }, [locations, locationsLoaded]);

  const handleLoadPlan = () => {
    if (Object.keys(selectedBuildings).length == 0) return;
    const buildings = selectedBuildings.value;
    if (onClickLoad) onClickLoad({ week, district, buildings });
  };

  React.useEffect(() => {
    EventEmitter.dispatch("districtChangeOrNone");
    setLoading(false);
  }, [district]);



 

  return (
    <div>
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <WeekPicker
            lbl={properCase(t("pgReview.lbWeekPicker"))}
            weekChangeHandler={weekChangeHandler}
            startDate = {selectedWeek}
          />
        </Grid>
        <Grid item>
          <FormControl className={classes.formControl}>
            <Autocomplete
              disabled={loading}
              id="districtSelector"
              options={districts}
              value={selectedDistrict}
              getOptionLabel={(option) => option.value}
              style={{ minWidth: 200 }}
              onInputChange={(event, newValue) => {
                if (!newValue) {
                  setDistrict(null);
                  setBuildings([]);
                  setSelectedBuildings([]);
                 // setAverageBy(null);
                  setSelectedPlan(null);
                  setPrimary(null);
                }
              }}
              onChange={(event, newValue) => {
                if (newValue && newValue.buildings) {
                  localStorage.setItem('dscDistrict', JSON.stringify(newValue));
                  setSelectedDistrict(newValue);
                  setDistrict(newValue.value);
                  setPrimary(newValue.value);
                  const filteredBuldings = newValue.buildings.length>0 ? newValue.buildings.filter(build => build.value !== CUSTOMER_SITE && build.value !== REMOTE ) :[]
                  setBuildings(filteredBuldings);
                  setSelectedBuildings([]);
                  setSelectedPlan(null);
                }
              }}
              renderInput={(params) => (
                <TextField {...params} label={t("general.select1")} />
              )}
            />
          </FormControl>
        </Grid>
        {/* <Grid item>
          <FormControl className={classes.formControl}>
            <Autocomplete
              //multiple
              disabled={loading}
              id="buildingSelector"
              options={buildings}
              value={selectedBuildings}
              //disableCloseOnSelect
              getOptionLabel={(option) => option.value || ""}
              style={{ minWidth: 200 }}
              onChange={(event, newValue) => {
                // console.log("new Value", newValue);
                if (newValue){
                  setPrimary(newValue.value);
                  setSelectedBuildings(newValue);
                }else{
                  setPrimary(null);
                  setSelectedBuildings({});
                }
                // if (newValue) {
                //   let isThere = false;
                //   for (let v of newValue) {
                //     if (v.label === primary) {
                //       isThere = true;
                //     }
                //   }
                //   if (!isThere) setPrimary(null);
                // }
              }}
              renderInput={(params) => (
                <TextField {...params} label={t("general.select2")} />
              )}
              // renderTags={(value, getTagProps) =>
              //   value.map((option, index) => (
              //     <Chip
              //       label={option.value}
              //       {...getTagProps({ index })}
              //       key={index}
              //       clickable
              //       color={primary === option.value ? "primary" : "default"}
              //       onClick={() => {
              //         setPrimary(option.value);
              //       }}
              //     />
              //   ))
              // }
            />
          </FormControl>
        </Grid> */}
        {/* <Grid item>
          <FormControl className={classes.formControl}>
            <Autocomplete
              disabled={loading}
              id="averageBySelector"
              options={averageByOptions}
              value={averageBy}
              getOptionLabel={(option) => option.name}
              style={{ minWidth: 200 }}
              onChange={(event, newValue) => {
                if (!newValue) {
                  setAverageBy({ id: "start" });
                } else {
                  setAverageBy(newValue);
                }
              }}
              renderInput={(params) => (
                <TextField {...params} label={"Select Average"} />
              )}
            />
          </FormControl>
        </Grid> */}
        {/* <Grid item>
          <Tooltip
            disableHoverListener={primary ? true : false}
            title="Click one of the buildings to mark as primary"
            arrow
          >
            <span>
              <Button
                color="primary"
                variant="outlined"
                onClick={handleLoadPlan}
                disabled={!primary}
              >
                View
              </Button>
            </span>
          </Tooltip>
        </Grid> */}
        {/* {existingPlans.length > 0 && (
          <Grid item>
            <FormControl>
              <Autocomplete
                disabled={loading}
                id="planSelector"
                options={existingPlans}
                value={selectedPlan}
                getOptionLabel={(option) => getPlanName(option)}
                style={{ minWidth: 200 }}
                onChange={(event, newValue) => {
                  setSelectedPlan(newValue);
                  if (onChangePlan) onChangePlan(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} label={"Select Plan"} />
                )}
              />
            </FormControl>
          </Grid>
        )} */}
      </Grid>
    </div>
  );
};

DropDowns.propTypes = {
  onChangeSelections: PropTypes.func,
  onChangeAverage: PropTypes.func,
  onChangePrimary: PropTypes.func,
  existingPlans: PropTypes.array,
  onClickLoad: PropTypes.func,
  loading: PropTypes.any,
  setLoading: PropTypes.func,
};

export default DropDowns;
